import {
  REQUEST_INFORMATION,
  REQUEST_PLATE,
  USER_INFORMATION,
  RESET_INQUIRES,
  RESET_USER,
  PLACES_ADRESS,
  ERROR_STATE,
  IS_REQUESTING
} from "./types";

export const getPlacesAdress = (name, value) => {
  return dispatch => {
    dispatch({
      type: PLACES_ADRESS,
      name: name,
      data: value
    });
  };
};

export const getRequestInfo = (section, value, name) => {
  if(name === 'plate'){
    value = value.replace(/[^a-zA-Z0-9.]/g, "");
    value = value.toUpperCase();
  }
  
  return dispatch => {
    dispatch({
      type: REQUEST_INFORMATION,
      section: section,
      name: name,
      data: value
    });
  };
};

export const getUserInfo = (value, name) => {
  if(name === 'phone_number'){
    value = value.replace(/[^0-9+]/g, "");
  }
  return dispatch => {
    dispatch({
      type: USER_INFORMATION,
      name: name,
      data: value
    });
  };
};

export const resetInquires = () => {
  return dispatch => {
    dispatch({
      type: RESET_INQUIRES
    });
  };
};

export const resetUser = () => {
  return dispatch => {
    dispatch({
      type: RESET_USER
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/inquires.js